import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center justify-between w-full" }
const _hoisted_2 = ["id", "placeholder"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "p-0 mb-1 -mt-2 text-sm text-red-500"
}

import { ref, onMounted, onBeforeUnmount, watch, watchEffect } from "vue";
	import { makeFakeID } from "@/utils";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchTag',
  props: {
		icon: {
			type: String,
			default: "/media/icons/arrow-down-icon.svg",
		},
		data: {
			type: String,
			default: "[]",
		},
		placeholder: {
			type: String,
			default: "Change the placeholder",
		},
		bgDropDown: {
			type: String,
			default: "bg-secondary",
		},
		css: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		error: {
			type: String,
			default: "",
		},
		selected: {
			type: [String, Number],
			default: '0',
		},
	},
  setup(__props) {

	const dropdownDiv = ref<any>(null);

	const dropdownID = ref<any>(makeFakeID(5));
	const listID = ref<any>(makeFakeID(5));
	const inputTagID = ref<any>(makeFakeID(5));
	const iconID = ref<any>(makeFakeID(5));
	const itemsList = ref<any>(null);
	const inputTag = ref<any>(null);
	const iconTag = ref<any>(null);
	const lock = ref(false);
	const isDropdownNotVisible = ref(true);

	// Create a new 'change' event
	const event = new Event("input");

	const props = __props;

	watch(
		() => props.data,
		(newValue: any) => {
			if (props.data) {
				itemsList.value?.replaceChildren(...fetchData(props.data));
			}
		}
	);

	// Initilisation du composant
	watchEffect(() => {
		if (props.selected != 0 && props.data != "[]" && inputTag.value) {
			let dataSelected: any = [];
			try {
				dataSelected = JSON.parse(props.data).filter((item: any) => item.key == props.selected);

				if (dataSelected[0]) {
					inputTag.value.value = dataSelected[0].value;
					inputTag.value.setAttribute("data-option", "");
					inputTag.value.dataset.option = JSON.stringify(dataSelected[0]);
				} else {
					inputTag.value.value = "";
					inputTag.value.setAttribute("data-option", "");
					inputTag.value.dataset.option = JSON.stringify({ key: 0, value: "" });
				}
				// Dispatch the INPUT event.
				inputTag.value.dispatchEvent(event);
			} catch (e) {
				console.error("Select Component -  \nCouldnt JSON parse : ", e);
			}
		}
	});

	watch(
		() => isDropdownNotVisible.value,
		(newValue: any) => {
			if (!iconTag.value) return;
			if (newValue) {
				iconTag.value.classList.remove("rotate-180");
			} else {
				iconTag.value.classList.add("rotate-180");
			}
		}
	);

	const setSelectedValue = (e: any, tagInput: any) => {
		tagInput.value.value = e.target.innerText;
		tagInput.value.setAttribute("data-option", "");
		tagInput.value.dataset.option = e.target.dataset.obj;

		// Dispatch it.
		tagInput.value.dispatchEvent(event);
	};

	const openDropdown = () => {
		isDropdownNotVisible.value = false;
	};

	const getDataFromProperty = (toParse: any) => {
		try {
			const parsed = JSON.parse(toParse);
			return Array.isArray(parsed) ? parsed : [];
		} catch (e) {
			console.error("Select Component -  \nCouldnt JSON parse : ", e);
			return [];
		}
	};

	const fetchData = (data: any) => {
		let nodes = (getDataFromProperty(data) || []).map((optionData: any) => {
			let elementListTag = document.createElement("li");
			elementListTag.setAttribute(
				"class",
				"break-words flex items-center min-h-6 border-b-1 border-white px-4 cursor-pointer hover:bg-accent hover:text-gray-800"
			);
			elementListTag.setAttribute("data-obj", JSON.stringify(optionData));
			elementListTag.textContent = optionData.value;
			return elementListTag;
		});
		return nodes;
	};

	onMounted(() => {
		// Initialisation
		dropdownDiv.value = document.getElementById(dropdownID.value);
		itemsList.value = document.querySelector("ul[id=" + listID.value + "]");
		inputTag.value = document.querySelector("input[id=" + inputTagID.value + "]");
		iconTag.value = document.getElementById(iconID.value);

		if (props.data) {
			itemsList.value?.replaceChildren(...fetchData(props.data));
		}

		// Listeners nommés → cleanup au unmount. Avant : closures
		// inline sans removeEventListener → leaks mémoire à chaque
		// démount du composant (utilisé partout dans l'app).
		const onItemsClick = (e: any) => setSelectedValue(e, inputTag);
		const onInputBlur = () => {
			isDropdownNotVisible.value = lock.value ? true : false;
			lock.value = false;
		};
		const onDocClickOutside = (evt: any) => {
			if (
				evt.target !== inputTag.value &&
				evt.target !== dropdownDiv.value &&
				evt.target !== itemsList.value
			) {
				isDropdownNotVisible.value = true;
			}
		};

		itemsList.value?.addEventListener("click", onItemsClick);
		inputTag.value?.addEventListener("blur", onInputBlur, true);
		document.addEventListener("click", onDocClickOutside);

		onBeforeUnmount(() => {
			itemsList.value?.removeEventListener("click", onItemsClick);
			inputTag.value?.removeEventListener("blur", onInputBlur, true);
			document.removeEventListener("click", onDocClickOutside);
		});
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col space-y-1",
    onClick: openDropdown
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
				__props.css,
				{
					'relative flex flex-row items-center px-4 py-2 space-x-4 bg-transparent border rounded-lg border-secondary focus-within:ring-2 focus-within:ring-secondary-700 focus-within:ring-inset': true,
				},
			]),
      onClick: openDropdown
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          id: inputTagID.value,
          type: "text",
          autocomplete: "no",
          class: "w-full text-white placeholder-gray-500 bg-transparent outline-none focus:outline-none autofill:bg-green-800 peer",
          placeholder: __props.placeholder,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('model', JSON.parse($event.target?.dataset?.option))))
        }, null, 40, _hoisted_2),
        _createVNode(_component_Icon, {
          id: iconID.value,
          src: __props.icon,
          css: "w-5 h-5",
          onClick: openDropdown
        }, null, 8, ["id", "src"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([
					__props.bgDropDown,
					{
						'-left-4 top-10 absolute w-full dropdown mr-10 z-50  overflow-y-auto custumScroll rounded-lg': true,
						hidden: isDropdownNotVisible.value,
					},
				]),
        id: dropdownID.value,
        style: {
					maxHeight: '10rem',
				}
      }, [
        _createElementVNode("ul", {
          class: "py-2 overflow-x-hidden break-words divide-y divide-gray-800",
          id: listID.value
        }, null, 8, _hoisted_4)
      ], 10, _hoisted_3)
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})